<template>
  <ul class="tab-links" role="tablist">
    <li
      v-for="(tab, index) in tabs"
      :key="index"
      :class="{
        'tab-links__item': true,
        'tab-links__item--active': activeTab === tab.id,
      }"
      role="presentation"
    >
      <router-link class="tab-links__link" :to="tab.url" :id="`tab_${index}`">
        {{ tab.label }}
      </router-link>
    </li>
  </ul>
</template>

<script>
  export default {
    name: 'tabs',
    props: {
      tabs: {
        type: Array,
        required: true,
      },
    },
    mounted() {
      if (this.$route.params.tab) {
        this.activeTab = this.$route.params.tab
      } else {
        this.activeTab = 'consumption'
      }
    },
    data() {
      return {
        activeTab: 0,
      }
    },
    watch: {
      $route(newRoute) {
        this.activeTab = newRoute.params.tab
      },
    },
  }
</script>

<style lang="scss">
  .tab-links {
    display: flex;
    justify-content: center;
    list-style: none;
    margin: spacer(1) 0 spacer(2);
    padding: 0;

    @media (min-width: $bp-md) {
      margin-bottom: spacer(3);
    }

    &__item {
      margin: 0 spacer(0.25);

      @media (min-width: $bp-xs) {
        margin: 0 spacer(0.25);
      }

      @media (min-width: $bp-md) {
        margin: 0 spacer(0.5);
      }
    }

    &__link {
      border-bottom: $tabs-border-width solid $tabs-border-inactive;
      display: block;
      transition: $transition-base;
      font-size: $tabs-font-size-min;
      padding: 0 spacer(0.5);
      color: $grey-dark;

      @media (min-width: $bp-xs) {
        font-size: $tabs-font-size-xs;
      }

      @media (min-width: $bp-md) {
        font-size: $tabs-font-size;
        padding: 0 spacer(0.75);
      }

      .tab-links__item--active &,
      &:hover,
      &:focus,
      &:active {
        border-bottom-color: $tabs-border-active;
        color: $grey-darker;
      }
    }
  }
</style>
